import { createSlice } from "@reduxjs/toolkit";
import { saveCompanyProfile} from "../actions/CompanyProfileAction";

const initialState={
    //save company profile
    loading:false,
    saveCmpPrf:null,
    error:null,
    success:false,
}

const companyProfileSlice = createSlice({
    name:"company-profile",
    initialState,
    extraReducers:(builder)=>{
        builder
        //get project type
        .addCase(saveCompanyProfile.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success =false;
        })
        .addCase(saveCompanyProfile.fulfilled, (state,{payload}) => {
            state.loading=false;
            state.typeList=payload;
            state.success=true;
            state.error=null;
        })
        .addCase(saveCompanyProfile.rejected,(state, {paylaod})=>{
            state.loading=false;
            state.error=paylaod;
            state.success=false;
        })
    }
});

export default companyProfileSlice.reducer;